export const normalizeDocument = value => {
  if (!value) return value;
  const onlyNumbers = value.replace(/[^\d]/g, "");
  if (onlyNumbers.length <= 3) return onlyNumbers;
  if (onlyNumbers.length <= 6)
      return `${onlyNumbers.slice(0, 3)}.${onlyNumbers.slice(3, 6)}`
  if (onlyNumbers.length <= 9)
      return `${onlyNumbers.slice(0, 3)}.${onlyNumbers.slice(3, 6)}.${onlyNumbers.slice(6, 9)}`
  if (onlyNumbers.length <= 12)
      return `${onlyNumbers.slice(0, 3)}.${onlyNumbers.slice(3, 6)}.${onlyNumbers.slice(6, 9)}-${onlyNumbers.slice(9, 12)}`
  if (onlyNumbers.length <= 14 || onlyNumbers.length > 14)
      return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(2, 5)}.${onlyNumbers.slice(5, 8)}/${onlyNumbers.slice(8, 12)}` +
             `-${onlyNumbers.slice(12, 14)}`
}

export const normalizeBarcode = value => {
    if (!value) return value;
    const onlyNumbers = value.replace(/[^\d]/g, "");
    if (onlyNumbers.length <= 5) return onlyNumbers;
    if (onlyNumbers.length <= 10)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)}`;
    if (onlyNumbers.length <= 15)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)} ${onlyNumbers.slice(10, 15)}`;
    if (onlyNumbers.length <= 21)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)} ${onlyNumbers.slice(10, 15)}.${onlyNumbers.slice(15, 21)}`;
    if (onlyNumbers.length <= 26)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)} ` + 
               `${onlyNumbers.slice(10, 15)}.${onlyNumbers.slice(15, 21)} ` +
               `${onlyNumbers.slice(21, 26)}`;
    if (onlyNumbers.length <= 31)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)} ` + 
               `${onlyNumbers.slice(10, 15)}.${onlyNumbers.slice(15, 21)} ` +
               `${onlyNumbers.slice(21, 26)}.${onlyNumbers.slice(26, 31)}`;
    if (onlyNumbers.length <= 32)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)} ` + 
               `${onlyNumbers.slice(10, 15)}.${onlyNumbers.slice(15, 21)} ` +
               `${onlyNumbers.slice(21, 26)}.${onlyNumbers.slice(26, 31)} ${onlyNumbers.slice(31, 32)}`;
    if (onlyNumbers.length <= 48 || onlyNumbers.length > 48)
        return `${onlyNumbers.slice(0, 5)}.${onlyNumbers.slice(5, 10)} ` + 
               `${onlyNumbers.slice(10, 15)}.${onlyNumbers.slice(15, 21)} ` +
               `${onlyNumbers.slice(21, 26)}.${onlyNumbers.slice(26, 31)} ` +
               `${onlyNumbers.slice(31, 32)} ${onlyNumbers.slice(32, 48)}`;
}

export const normalizeDate = value => {
    if (!value) return value;
    const onlyNumbers = value.replace(/[^\d]/g, "");
    if (onlyNumbers.length <= 2) return onlyNumbers;
    if (onlyNumbers.length <= 4) return `${onlyNumbers.slice(0, 2)}/${onlyNumbers.slice(2, 4)}`;
    if (onlyNumbers.length <= 8 || onlyNumbers.length > 8)
        return `${onlyNumbers.slice(0, 2)}/${onlyNumbers.slice(2, 4)}/${onlyNumbers.slice(4, 8)}`;
}

export const normalizeValue = value => {
    const onlyNumbers = value.replace(/[^\d]/g, "");
    if (!onlyNumbers) return onlyNumbers;
    if (onlyNumbers.length <= 1) return "R$ " + onlyNumbers;
    if (onlyNumbers.length <= 2)
        return `R$ ${onlyNumbers.slice(0, 1)},${onlyNumbers.slice(1, 2)}`;
    if (onlyNumbers.length <= 3)
        return `R$ ${onlyNumbers.slice(0, 1)},${onlyNumbers.slice(1, 3)}`;
    if (onlyNumbers.length > 3)
        return `R$ ${onlyNumbers.slice(0, onlyNumbers.length-2)},${onlyNumbers.slice(onlyNumbers.length-2, onlyNumbers.length)}`;
}


// WEBPACK FOOTER //
// ./src/Common/normalize.js